export default "__VITE_ASSET__C2NkFVvz__"